function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 16"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  strokeOpacity: ".2",
  strokeWidth: ".5",
  x: ".25",
  y: ".25",
  width: "23.5",
  height: "15.5",
  rx: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.79 5.91A7.2 7.2 0 001 5.24l.03-.13h2.74c.37.01.67.13.77.52l.59 2.84.18.85 1.67-4.2h1.8L6.1 11.27H4.3L2.8 5.9zm7.31 5.37H8.4l1.06-6.17h1.7l-1.06 6.17zm6.17-6.02l-.24 1.34-.15-.07a3.05 3.05 0 00-1.27-.24c-.67 0-.97.27-.98.53 0 .3.37.48.96.77.98.44 1.44.98 1.43 1.68-.01 1.28-1.17 2.1-2.96 2.1a5.5 5.5 0 01-1.9-.32l.24-1.39.23.1c.55.23.91.33 1.6.33.48 0 1-.2 1.01-.6 0-.27-.22-.47-.88-.77-.64-.3-1.5-.8-1.49-1.68 0-1.2 1.19-2.04 2.87-2.04.66 0 1.19.14 1.53.26zm2.26 3.84h1.41l-.39-1.79-.12-.53-.22.59-.68 1.73zm2.1-3.99L22 11.28h-1.57l-.2-.92h-2.2l-.35.92H15.9l2.52-5.66c.18-.4.49-.5.9-.5h1.3z"
}))));